import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { signIn }  = useAuth();
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState<string | null>(null);
  const [loading,  setLoading]  = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const err = await signIn(email, password);
    if (err) {
      setError("Invalid email or password. Please try again.");
      setLoading(false);
    }
    // On success AuthContext updates and App.tsx shows dashboard automatically
  }

  return (
    <div style={{
      minHeight:       "100vh",
      backgroundColor: "#060E17",
      display:         "flex",
      alignItems:      "center",
      justifyContent:  "center",
      fontFamily:      "Inter, sans-serif",
    }}>
      <div style={{
        width:           "360px",
        backgroundColor: "#0F1C2E",
        borderRadius:    "12px",
        border:          "1px solid #1E3A5F",
        padding:         "40px 36px",
        boxShadow:       "0 24px 48px rgba(0,0,0,0.4)",
      }}>
        {/* Logo */}
        <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"32px" }}>
          <div style={{
            width:"36px", height:"36px",
            backgroundColor:"#C9A84C",
            borderRadius:"8px",
            display:"flex", alignItems:"center", justifyContent:"center",
            fontWeight:700, fontSize:"14px", color:"#0F1C2E",
          }}>
            AP
          </div>
          <div>
            <div style={{ fontSize:"14px", fontWeight:700, color:"#FFFFFF" }}>AMPM Fashions</div>
            <div style={{ fontSize:"10px", color:"#C9A84C", fontWeight:500, letterSpacing:"0.5px" }}>CEO COCKPIT</div>
          </div>
        </div>

        {/* Title */}
        <div style={{ marginBottom:"24px" }}>
          <h1 style={{ fontSize:"20px", fontWeight:700, color:"#FFFFFF", margin:0 }}>Sign in</h1>
          <p style={{ fontSize:"12px", color:"#64748B", margin:"4px 0 0" }}>Enter your credentials to continue</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          {/* Email */}
          <div style={{ marginBottom:"16px" }}>
            <label style={{ display:"block", fontSize:"11px", fontWeight:600, color:"#94A3B8", marginBottom:"6px", textTransform:"uppercase", letterSpacing:"0.5px" }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@ampm.in"
              required
              style={{
                width:"100%", padding:"10px 12px",
                borderRadius:"6px", border:"1px solid #1E3A5F",
                backgroundColor:"#060E17", color:"#FFFFFF",
                fontSize:"13px", boxSizing:"border-box",
                outline:"none",
              }}
            />
          </div>

          {/* Password */}
          <div style={{ marginBottom:"24px" }}>
            <label style={{ display:"block", fontSize:"11px", fontWeight:600, color:"#94A3B8", marginBottom:"6px", textTransform:"uppercase", letterSpacing:"0.5px" }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={{
                width:"100%", padding:"10px 12px",
                borderRadius:"6px", border:"1px solid #1E3A5F",
                backgroundColor:"#060E17", color:"#FFFFFF",
                fontSize:"13px", boxSizing:"border-box",
                outline:"none",
              }}
            />
          </div>

          {/* Error message */}
          {error && (
            <div style={{
              padding:"10px 12px", borderRadius:"6px",
              backgroundColor:"rgba(220,38,38,0.1)",
              border:"1px solid rgba(220,38,38,0.3)",
              color:"#F87171", fontSize:"12px", marginBottom:"16px",
            }}>
              {error}
            </div>
          )}

          {/* Submit button */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width:"100%", padding:"11px",
              borderRadius:"6px", border:"none",
              backgroundColor: loading ? "#7C6730" : "#C9A84C",
              color:"#0F1C2E", fontSize:"13px", fontWeight:700,
              cursor: loading ? "default" : "pointer",
              transition:"background-color 0.15s",
            }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
